module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wbx_home1"
  }, [_c('group', {
    attrs: {
      "gutter": "0.77em"
    }
  }, [_c('cell', {
    staticClass: "spaa",
    attrs: {
      "title": "姓名"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.userName))])]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "手机号"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.mobile))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "queding"
  }, [_c('x-button', {
    staticClass: "btn-new-sty",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClick('/xinxi/')
      }
    }
  }, [_vm._v("修改")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6707b38d"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/detail.vue
// module id = 340
// module chunks = 0